import { FC } from "react";
import { IconPropsType } from ".";

export const Search: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8.5" cy="7.5" r="6.5" stroke={props.color} strokeWidth="2" />
      <line
        x1="3"
        y1="14.4142"
        x2="1.41421"
        y2="16"
        stroke={props.color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
